// extracted by mini-css-extract-plugin
export default {"AppService":"AppService_AppService__zjSk9","AppService__wrap":"AppService_AppService__wrap__xs2A3"};